var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_4817_153748)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.359375,
    width: 31.6732,
    height: 31.6732,
    rx: 15.8366,
    fill: "#EFF4F8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.176H21.15V15.026V12.3594C21.15 8.9432 18.4162 6.20937 15 6.20937C11.5838 6.20937 8.85 8.9432 8.85 12.3594V15.026V15.176H9H10.3333H10.4833V15.026V12.3594C10.4833 9.84222 12.4828 7.84271 15 7.84271C17.5172 7.84271 19.5167 9.84222 19.5167 12.3594V15.026V15.176H19.6667H21Z",
    fill: "#1C1C1C",
    stroke: "#4E4E57",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 26.5094H20.3346C21.5508 26.5094 22.4846 25.5756 22.4846 24.3594V16.3594C22.4846 15.1432 21.5508 14.2094 20.3346 14.2094H9.66797C8.45179 14.2094 7.51797 15.1432 7.51797 16.3594V24.3594C7.51797 25.5756 8.45179 26.5094 9.66797 26.5094ZM9.1513 16.3594C9.1513 16.1935 9.20595 16.0669 9.2907 15.9821C9.37545 15.8974 9.50206 15.8427 9.66797 15.8427H20.3346C20.5005 15.8427 20.6272 15.8974 20.7119 15.9821C20.7967 16.0669 20.8513 16.1935 20.8513 16.3594V24.3594C20.8513 24.5253 20.7967 24.6519 20.7119 24.7366C20.6272 24.8214 20.5005 24.876 20.3346 24.876H9.66797C9.50206 24.876 9.37545 24.8214 9.2907 24.7366C9.20595 24.6519 9.1513 24.5253 9.1513 24.3594V16.3594Z",
    fill: "#1C1C1C",
    stroke: "#4E4E57",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 19.6921C15.7377 19.6921 16.3346 19.0951 16.3346 18.3587C16.3346 17.6223 15.7377 17.0254 15.0013 17.0254C14.2649 17.0254 13.668 17.6223 13.668 18.3587C13.668 19.0951 14.2649 19.6921 15.0013 19.6921Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 18.3594H14.6667L14 22.3594H16L15.3333 18.3594Z",
    fill: "#1C1C1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_4817_153748",
    x: -5,
    y: -4.64062,
    width: 40.6719,
    height: 40.6738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.531406 0 0 0 0 0.624874 0 0 0 0 0.7125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4817_153748"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4817_153748",
    result: "effect2_innerShadow_4817_153748"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bc189b373298f38e9499200f867a7c3e.svg";
export { ForwardRef as ReactComponent };